/** ----------------------------------------
    KVK
---------------------------------------- */

import { Validator } from 'vee-validate';

Validator.extend('kvk', {
    validate (value) {
        return !isNaN(value) && value.length === 8;
    },
    getMessage (field) {
        return `Een KvK-nummer bestaat uit acht cijfers.`;
    }
});